<template>
    <div class="row align-items-center">
        <div class="col-11 pr-0">
            <ValidationObserver :ref="'reference'+ reference.name" class="row">

                <ValidationProvider name="Reference: Name"
                                    rules="latin|min:2|max:30"
                                    v-slot="{errors}"
                                    class="col-md-4">
                    <div class="form-group form-group-1">
                        <label for="" class="form-label">Name</label>
                        <input type="text" class="form-control" v-model="reference.name">
                        <FormError :error="errors[0]" name="Reference: Name"></FormError>
                    </div>
                </ValidationProvider>

                <ValidationProvider name="Reference: How long know"
                                    rules="latinAndNumbers"
                                    v-slot="{errors}"
                                    class="col-md-4">
                    <div class="form-group form-group-1">
                        <label for="" class="form-label">How long know</label>
                        <input type="text" class="form-control" v-model="reference.term_know">
                        <FormError :error="errors[0]" name="Reference: How long know"></FormError>
                    </div>
                </ValidationProvider>

                <ValidationProvider name="Reference: Phone"
                                    rules="customMin:17"
                                    v-slot="{errors}"
                                    class="col-md-4">
                    <div class="form-group form-group-1">
                        <label for="" class="form-label">Telephone / Fax</label>
                        <input type="text" class="form-control"
                               v-mask="'+1 (###) ###-####'"
                               v-model="reference.phone">
                        <FormError :error="errors[0]" name="Reference: Phone"></FormError>
                    </div>
                </ValidationProvider>
            </ValidationObserver>
        </div>
        <div class="col-1" v-if="lengthRef > 1">
            <a  href="javascript:void(0)" class="delete-link" @click.prevent="$emit('delete-reference', reference.id)"
            ><img src="/uploads/img/svg/on.svg" alt="delete">
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'EmployeeReferences',
    emits:['delete-reference'],
    props: {
        user: {
           type:Object
        },
        reference: {
            type: Object,
        },
        lengthRef: {
            type: Number,
            required: true,
        }
    },
}

</script>

<style scoped>

</style>
